import { addressValid, fieldValid, textValid } from 'helpers';

export const PII_PROFILE_APPROVED_STATUS = 'APPROVED';
export const PII_PROFILE_PENDING_PII_STATUS = 'PENDING_PII';
export const PII_PROFILE_PENDING_DOCUMENTS_STATUS = 'PENDING_ID_DOCUMENTS';

export const AUTH_REFRESH_SUCCESS_STATUS = 'SUCCESS';

export const PROFILE_PENDING_OTP_VERIFICATION_STATUS =
  'PENDING_OTP_VERIFICATION';
export const PROFILE_ALREADY_REGISTRED_STATUS = 'ALREADY_REGISTRED';
export const PROFILE_SHOW_CONTACT_US_STATUS = 'SHOW_CONTACT_US';

export const PII_PROFILE_PERSONAL_DETAILS_FISTNAME_NAME =
  'pii-profile-personal-details-first-name-field';
export const PII_PROFILE_PERSONAL_DETAILS_MIDDLENAME_NAME =
  'pii-profile-personal-details-middle-name-field';
export const PII_PROFILE_PERSONAL_DETAILS_LASTNAME_NAME =
  'pii-profile-personal-details-last-name-field';
export const PII_PROFILE_PERSONAL_DETAILS_GENDER_NAME =
  'pii-profile-personal-details-gender-field';
export const PII_PROFILE_PERSONAL_DETAILS_DOB_NAME =
  'pii-profile-personal-details-dob-field';
export const PII_PROFILE_PERSONAL_DETAILS_OCCUPATION_NAME =
  'pii-profile-personal-details-occupation-field';
export const PII_PROFILE_PERSONAL_DETAILS_PREVIOUS_EMPLOYED_NAME =
  'pii-profile-personal-details-previous-employed-field';

export const PII_PROFILE_PERSONAL_DETAILS_FISTNAME_FIELD = {
  label: 'form_first_name',
  name: PII_PROFILE_PERSONAL_DETAILS_FISTNAME_NAME,
  type: 'text',
  placeholder: 'form_first_name',
  tooltip: 'form_name_tooltip_1',
  isRequired: true,
  isReadOnly: false,
  msgInvalid: 'form_name_invalid_1',
  msgRequired: 'form_required',
  checkValidFn: textValid,
};
export const PII_PROFILE_PERSONAL_DETAILS_MIDDLENAME_FIELD = {
  label: 'form_middle_name',
  name: PII_PROFILE_PERSONAL_DETAILS_MIDDLENAME_NAME,
  type: 'text',
  placeholder: 'form_middle_name',
  tooltip: 'form_name_tooltip_2',
  isRequired: false,
  isReadOnly: false,
  msgInvalid: 'form_name_invalid_1',
  msgRequired: 'form_required',
  checkValidFn: textValid,
};
export const PII_PROFILE_PERSONAL_DETAILS_LASTNAME_FIELD = {
  label: 'form_last_name',
  name: PII_PROFILE_PERSONAL_DETAILS_LASTNAME_NAME,
  type: 'text',
  placeholder: 'form_last_name',
  tooltip: 'form_name_tooltip_3',
  isRequired: true,
  isReadOnly: false,
  msgInvalid: 'form_name_invalid_1',
  msgRequired: 'form_required',
  checkValidFn: textValid,
};
export const PII_PROFILE_PERSONAL_DETAILS_GENDER_FIELD = {
  label: 'form_gender',
  name: PII_PROFILE_PERSONAL_DETAILS_GENDER_NAME,
  type: 'radio',
  isRequired: true,
  isReadOnly: false,
  msgRequired: '',
  checkValidFn: textValid,
};
export const PII_PROFILE_PERSONAL_DETAILS_DOB_FIELD = {
  label: 'form_date_of_birth',
  name: PII_PROFILE_PERSONAL_DETAILS_DOB_NAME,
  type: 'text',
  placeholder: 'DD/MM/YYYY',
  isRequired: true,
  isReadOnly: false,
  msgInvalid: 'form_date_of_birth_invalid_1',
  msgInvalid2: 'form_date_of_birth_invalid_2',
  msgRequired: '',
  checkValidFn: fieldValid,
};
export const PII_PROFILE_PERSONAL_DETAILS_OCCUPATION_FIELD = {
  label: 'form_occupation',
  name: PII_PROFILE_PERSONAL_DETAILS_OCCUPATION_NAME,
  type: 'text',
  placeholder: 'form_placeholder_please_select',
  isRequired: true,
  isReadOnly: false,
  msgRequired: 'form_required',
  checkValidFn: textValid,
};
export const PII_PROFILE_PERSONAL_DETAILS_PREVIOUS_EMPLOYED_FIELD = {
  label: 'form_previous_employed',
  name: PII_PROFILE_PERSONAL_DETAILS_PREVIOUS_EMPLOYED_NAME,
  type: 'text',
  placeholder: 'form_placeholder_please_select',
  isRequired: true,
  isReadOnly: false,
  msgRequired: 'form_required',
  checkValidFn: textValid,
};

export const PII_PROFILE_RESIDENTIAL_ADDRESS_FINDER_NAME =
  'pii-profile-residential-finder-field';
export const PII_PROFILE_RESIDENTIAL_ADDRESS_SWITCH_NAME =
  'pii-profile-residential-switch-field';
export const PII_PROFILE_RESIDENTIAL_ADDRESS_UNITNAME_NAME =
  'pii-profile-residential-manual-unit-field';
export const PII_PROFILE_RESIDENTIAL_ADDRESS_STREET_NO_NAME =
  'pii-profile-residential-manual-street-no-field';
export const PII_PROFILE_RESIDENTIAL_ADDRESS_STREET_NAME_NAME =
  'pii-profile-residential-manual-street-name-field';
export const PII_PROFILE_RESIDENTIAL_ADDRESS_STREET_TYPE_NAME =
  'pii-profile-residential-manual-street-type-field';
export const PII_PROFILE_RESIDENTIAL_ADDRESS_POST_CODE_NAME =
  'pii-profile-residential-manual-post-code-field';
export const PII_PROFILE_RESIDENTIAL_ADDRESS_SUBURB_NAME =
  'pii-profile-residential-manual-suburb-field';
export const PII_PROFILE_RESIDENTIAL_ADDRESS_STATE_NAME =
  'pii-profile-residential-manual-state-field';

export const PII_PROFILE_RESIDENTIAL_ADDRESS_FINDER_FIELD = {
  label: 'form_address_finder',
  name: PII_PROFILE_RESIDENTIAL_ADDRESS_FINDER_NAME,
  type: 'text',
  placeholder: 'form_placeholder_type_to_search',
  isRequired: true,
  isReadOnly: false,
  msgRequired: 'form_required',
  checkValidFn: textValid,
};
export const PII_PROFILE_RESIDENTIAL_ADDRESS_SWITCH_FIELD = {
  label: 'button_address_manual_switch',
  name: PII_PROFILE_RESIDENTIAL_ADDRESS_SWITCH_NAME,
};
export const PII_PROFILE_RESIDENTIAL_ADDRESS_UNITNAME_FIELD = {
  label: 'form_address_unit',
  name: PII_PROFILE_RESIDENTIAL_ADDRESS_UNITNAME_NAME,
  type: 'text',
  placeholder: 'form_placeholder',
  isRequired: false,
  isReadOnly: false,
  msgInvalid: 'form_address_invalid_1',
  msgRequired: 'form_required',
  checkValidFn: addressValid,
};
export const PII_PROFILE_RESIDENTIAL_ADDRESS_STREET_NO_FIELD = {
  label: 'form_address_street_no',
  name: PII_PROFILE_RESIDENTIAL_ADDRESS_STREET_NO_NAME,
  type: 'text',
  placeholder: 'form_placeholder',
  isRequired: true,
  isReadOnly: false,
  msgInvalid: 'form_address_invalid_1',
  msgRequired: 'form_required',
  checkValidFn: addressValid,
};
export const PII_PROFILE_RESIDENTIAL_ADDRESS_STREET_NAME_FIELD = {
  label: 'form_address_street_name',
  name: PII_PROFILE_RESIDENTIAL_ADDRESS_STREET_NAME_NAME,
  type: 'text',
  placeholder: 'form_placeholder',
  isRequired: true,
  isReadOnly: false,
  msgInvalid: 'form_address_invalid_1',
  msgRequired: 'form_required',
  checkValidFn: addressValid,
};
export const PII_PROFILE_RESIDENTIAL_ADDRESS_STREET_TYPE_FIELD = {
  label: 'form_address_street_type',
  name: PII_PROFILE_RESIDENTIAL_ADDRESS_STREET_TYPE_NAME,
  type: 'text',
  placeholder: 'form_placeholder_please_select',
  isRequired: true,
  isReadOnly: false,
  msgRequired: 'form_required',
  checkValidFn: textValid,
};
export const PII_PROFILE_RESIDENTIAL_ADDRESS_POST_CODE_FIELD = {
  label: 'form_address_post_code',
  name: PII_PROFILE_RESIDENTIAL_ADDRESS_POST_CODE_NAME,
  type: 'number',
  placeholder: 'form_placeholder_type_to_search_postcode',
  isRequired: true,
  isReadOnly: true,
  msgInvalid: 'form_name_invalid_1',
  msgRequired: 'form_required',
  checkValidFn: addressValid,
};
export const PII_PROFILE_RESIDENTIAL_ADDRESS_SUBURB_FIELD = {
  label: 'form_address_suburb',
  name: PII_PROFILE_RESIDENTIAL_ADDRESS_SUBURB_NAME,
  type: 'text',
  placeholder: '-',
  isRequired: true,
  isReadOnly: true,
  msgRequired: 'form_required',
  checkValidFn: textValid,
};
export const PII_PROFILE_RESIDENTIAL_ADDRESS_STATE_FIELD = {
  label: 'form_address_state',
  name: PII_PROFILE_RESIDENTIAL_ADDRESS_STATE_NAME,
  type: 'text',
  placeholder: '-',
  isRequired: true,
  isReadOnly: true,
  msgRequired: 'form_required',
  checkValidFn: textValid,
};

export const RESET_PII_PROFILE_PERSONAL_DETAILS = {
  [PII_PROFILE_PERSONAL_DETAILS_FISTNAME_NAME]: '',
  [PII_PROFILE_PERSONAL_DETAILS_MIDDLENAME_NAME]: '',
  [PII_PROFILE_PERSONAL_DETAILS_LASTNAME_NAME]: '',
  [PII_PROFILE_PERSONAL_DETAILS_GENDER_NAME]: '',
  [PII_PROFILE_PERSONAL_DETAILS_DOB_NAME]: '',
  [PII_PROFILE_PERSONAL_DETAILS_OCCUPATION_NAME]: '',
  [PII_PROFILE_PERSONAL_DETAILS_PREVIOUS_EMPLOYED_NAME]: '',
};
export const RESET_PII_PROFILE_RESIDENTIAL_ADDRESS = {
  [PII_PROFILE_RESIDENTIAL_ADDRESS_FINDER_NAME]: '',
  [PII_PROFILE_RESIDENTIAL_ADDRESS_SWITCH_NAME]: false,
  [PII_PROFILE_RESIDENTIAL_ADDRESS_UNITNAME_NAME]: '',
  [PII_PROFILE_RESIDENTIAL_ADDRESS_STREET_NO_NAME]: '',
  [PII_PROFILE_RESIDENTIAL_ADDRESS_STREET_NAME_NAME]: '',
  [PII_PROFILE_RESIDENTIAL_ADDRESS_STREET_TYPE_NAME]: '',
  [PII_PROFILE_RESIDENTIAL_ADDRESS_POST_CODE_NAME]: '',
  [PII_PROFILE_RESIDENTIAL_ADDRESS_SUBURB_NAME]: '',
  [PII_PROFILE_RESIDENTIAL_ADDRESS_STATE_NAME]: '',
};
export const RESET_SIGNUP_PII_INFORMATION = {
  personalDetails: RESET_PII_PROFILE_PERSONAL_DETAILS,
  residentialAddress: RESET_PII_PROFILE_RESIDENTIAL_ADDRESS,
};
